<template>
  <div>
    <!-- 默认地址修改 -->
    <el-dialog :title="detail.editNoType" :close-on-click-modal="false" :visible.sync="dialogVisible" width="588px"
      center>
      <div class="content">

        <!--类型-->
        <div class="label">{{ detail.editNoType }}：</div>
        <div class="val">
          <el-input v-model="detail.tax_no" onfocus="this.select()" :placeholder="detail.editNoType"
            v-if="detail.editNoType == '法人番号'"></el-input>
          <el-input v-model="detail.bank_no" onfocus="this.select()" :placeholder="detail.editNoType"
            v-if="detail.editNoType == 'リアルタイム口座'"></el-input>

          <el-input v-model="detail.standard_no" onfocus="this.select()" :placeholder="detail.editNoType"
            v-if="detail.editNoType == '標準コード'"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        tax_no: this.detail.tax_no,
        bank_no: this.detail.bank_no,
        standard_no: this.detail.standard_no,
      };
      if (this.detail.editNoType == "法人番号") {
        this.$api.clienteleApi.setTaxNo(datas).then((res) => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.$parent.clientDetail();
        });
      }
      if (this.detail.editNoType == "標準コード") {
        this.$api.clienteleApi.setStandardNo(datas).then((res) => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.$parent.clientDetail();
        });
      }
      if (this.detail.editNoType == "リアルタイム口座") {
        this.$api.clienteleApi.setBankNo(datas).then((res) => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.$parent.clientDetail();
        });
      }

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 2.5;
  }
}
</style>